module.exports = __webpack_public_path__ + "static/media/minimal-video.5cdfee37.jpg";